<template>
    <div class="maintenance-view">
        <img class="logo" :src="require('@/assets/ARGOstqr_Digital_logo_banner.png')" />

        <h1>Nous revenons très vite</h1>

        <span><i class="icon-cogs"></i></span>

        <p>
            Nous effectuons une maintenance de l'application pour vous faire profiter de nos
            dernières idées :)
        </p>
    </div>
</template>
<script>
export default {
    name: "MaintenanceView"
};
</script>

<style scoped>
.maintenance-view {
    padding: 10px;
    color: var(--dark);
}

body.desktop .maintenance-view {
    color: var(--light);
}

h1 {
    font-weight: bold;
}

.logo {
    width: 200px;
}

.icon-cogs {
    font-size: 5em;
    margin-bottom: 15px;
}

p {
    font-weight: bold;
}
</style>
